import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const elements = 
{
    namespaced: true,
    state: {
        elements: [],
        element: {}
    },
    mutations: {
        SET_ELEMENTS(state, data)
        {
            state.elements = data
        },
        SET_ELEMENT(state, data)
        {
            state.element = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'Elements', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_ELEMENTS', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deleteElement ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updateElement({ commit }, {id, data}){
            return axios
            .post(baseUrl+'Elements/updateElement/'+id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getElement ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewElement ({ commit }, data) {
            return axios
            .post(baseUrl+'Elements/addElement', data, { withCredentials: true })
            .then(res => {
                console.log("new element added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default elements